// resources/js/router.js
import { createRouter, createWebHistory } from 'vue-router';
import routes from './routes';
import auth from './classes/auth';
import { membersRoute } from './constants';

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    return { left: 0, top: 0 };
  },
});

// Centralized navigation guards
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (auth.check()) {
      next();
      return;
    }
    next('/');
    return;
  }

  if (to.matched.some(record => record.meta.guest)) {
    if (!auth.check()) {
      next();
      return;
    }
    next(membersRoute);
    return;
  }

  if (to.matched.some(record => record.meta.admin)) {
    if (auth.check() && auth.user && auth.user.user_type === 0) {
      next();
      return;
    }
    next(membersRoute);
    return;
  }

  next();
});

export default router;
